module.exports = __webpack_public_path__ + "static/media/privacy.7b281bb5.md";